import React from "react";
import firebase from "../../firebase";
import config from "../../config/config";
import upiQRCode from "../../images/upiQRCode.jpg";

class RegisterForCourse extends React.Component {
    constructor(props) {
        super(props);

        this.ref = firebase.firestore().collection(config.courseEnrollmentsPath);

        this.state = {
            program: props.program,
            course: props.course,
            isLoading: false,
            fullName: '',
            collegeName: '',
            branchOfStudy: '',
            otherBranchOfStudy: '',
            yearOfStudy: '',
            phoneNumber: '',
            emailId: '',
            howDoYouKnowAboutUs: '',
            errors: {},
            formIsValid: true,
            errorMsg: 'Please fill all the details',
            successMsg: ''
        };
    }

    handleInputChange = event => {
        this.setState({[event.target.id]: event.target.value});
    };

    saveDetails = () => {
        if(this.validateForm()) {
            this.setState({
                isLoading: true,
            });
            this.ref.add({
                program: this.state.program,
                course: this.state.course,
                fullName: this.state.fullName,
                collegeName: this.state.collegeName,
                branchOfStudy: this.state.branchOfStudy,
                otherBranchOfStudy: this.state.otherBranchOfStudy,
                yearOfStudy: this.state.yearOfStudy,
                phoneNumber: this.state.phoneNumber,
                emailId: this.state.emailId,
                howDoYouKnowAboutUs: this.state.howDoYouKnowAboutUs
            }).then((docRef) => {
                this.setState({
                    isLoading: false,
                    fullName: '',
                    collegeName: '',
                    branchOfStudy: '',
                    otherBranchOfStudy: '',
                    yearOfStudy: '',
                    phoneNumber: '',
                    emailId: '',
                    howDoYouKnowAboutUs: '',
                    successMsg: 'Your details are saved successfully. Thanks for showing interest in taking this course. We will reach out to you personally to take things forward.'
                });
            })
                .catch((error) => {
                    console.error("Error saving details: ", error);
                    this.setState({
                        isLoading: false,
                        errorMsg: 'Error saving details, please try again later'
                    });
                });
        }
    };

    validateForm() {
        let formIsValid = true;
        let errors = {};

        if(this.state.fullName === ''){
            formIsValid = false;
            errors["fullName"] = "*Please enter your Full Name";
        } else {
            if(!this.state.fullName.match(/^[a-zA-Z ]*$/)){
                formIsValid = false;
                errors["fullName"] = "*Please enter alphabet characters only";
            }
        }

        if(this.state.collegeName === ''){
            formIsValid = false;
            errors["collegeName"] = "*Please enter your College Name";
        } else {
            if(!this.state.collegeName.match(/^[a-zA-Z ]*$/)){
                formIsValid = false;
                errors["collegeName"] = "*Please enter alphabet characters only";
            }
        }

        if(this.state.branchOfStudy === ''){
            formIsValid = false;
            errors["branchOfStudy"] = "*Please enter your branch of study";
        } else {
            if(this.state.branchOfStudy === 'Other'){
                if(this.state.otherBranchOfStudy === ''){
                    formIsValid = false;
                    errors["otherBranchOfStudy"] = "*Please enter your branch of study";
                }
            }
        }

        if(this.state.yearOfStudy === ''){
            formIsValid = false;
            errors["yearOfStudy"] = "*Please enter your year of study";
        }

        if(this.state.emailId === ''){
            formIsValid = false;
            errors["emailId"] = "*Please enter your Email id";
        } else {
            const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(this.state.emailId)) {
                formIsValid = false;
                errors["emailId"] = "*Please enter valid Email id";
            }
        }

        if(this.state.phoneNumber === ''){
            formIsValid = false;
            errors["phoneNumber"] = "*Please enter your Phone Number";
        } else {
            if (!this.state.phoneNumber.match(/^[0-9]{10}$/)) {
                formIsValid = false;
                errors["phoneNumber"] = "*Please enter valid 10 digit phone number";
            }
        }

        if(this.state.howDoYouKnowAboutUs === ''){
            formIsValid = false;
            errors["howDoYouKnowAboutUs"] = "*Please share how you got to know about us";
        }

        this.setState({
            errors: errors,
            formIsValid: formIsValid
        });

        return formIsValid;
    }

    render() {
        const {price} = this.props;
        return (
            <div className="container-fluid">
                {this.state.isLoading ?
                    <div id="overlay" className="spinner-border text-info" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    : <div/>
                }
                <div className="container">
                    <div className="form-group float-label-control">
                        <input id="fullName" type="text" className="form-control" placeholder="Full Name (Firstname Lastname)"
                               onChange={this.handleInputChange} value={this.state.fullName}/>
                        <div className="errorMsg">{this.state.errors.fullName}</div>
                    </div>
                    <div className="form-group float-label-control">
                        <input id="collegeName" type="text" className="form-control" placeholder="Name of the College"
                               onChange={this.handleInputChange} value={this.state.collegeName}/>
                        <div className="errorMsg">{this.state.errors.collegeName}</div>
                    </div>
                    <div className="form-group">
                        <div className="inputGroupContainer">
                            <div className="form-group">
                                <label htmlFor="branchOfStudy">Branch of Study</label>
                                <select className="form-control" id="branchOfStudy"
                                        onChange={this.handleInputChange}
                                        value={this.state.branchOfStudy}>
                                    <option value="Select">Select</option>
                                    <option value="Computer Science">Computer Science</option>
                                    <option value="Information Technology">Information Technology
                                    </option>
                                    <option value="Electronics & Communications">Electronics &
                                        Communications
                                    </option>
                                    <option value="Electrical">Electrical</option>
                                    <option value="Mechanical">Mechanical</option>
                                    <option value="Civil">Civil</option>
                                    <option value="Chemical">Chemical</option>
                                    <option value="Bio Informatics">Bio Informatics</option>
                                    <option value="Instrumentation">Instrumentation</option>
                                    <option value="Petroleum">Petroleum</option>
                                    <option value="Aeronautical">Aeronautical</option>
                                    <option value="Mining">Mining</option>
                                    <option value="Marine">Marine</option>
                                    <option value="Automobile">Automobile</option>
                                    <option value="Textile">Textile</option>
                                    <option value="Other">Other</option>
                                </select>
                                <div className="errorMsg">{this.state.errors.branchOfStudy}</div>
                            </div>
                        </div>
                    </div>
                    {
                        this.state.branchOfStudy === 'Other' ?
                            <div className="form-group">
                                <div className="col-md-8 inputGroupContainer">
                                    <div className="form-group">
                                        <input
                                            id="otherBranchOfStudy" name="otherBranchOfStudy"
                                            placeholder="Branch of Study"
                                            className="form-control" type="text"
                                            onChange={this.handleInputChange}
                                            value={this.state.otherBranchOfStudy}/>
                                        <div className="errorMsg">{this.state.errors.otherBranchOfStudy}</div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div />
                    }
                    <div className="form-group">
                        <div className="inputGroupContainer">
                            <div className="form-group">
                                <label htmlFor="yearOfStudy">Year of Study</label>
                                <select className="form-control" id="yearOfStudy"
                                        onChange={this.handleInputChange}
                                        value={this.state.yearOfStudy}>
                                    <option value="Select">Select</option>
                                    <option value="1">1st Year</option>
                                    <option value="2">2nd Year</option>
                                    <option value="3">3rd Year</option>
                                    <option value="4">4th Year</option>
                                    <option value="Others">Others</option>
                                </select>
                                <div className="errorMsg">{this.state.errors.yearOfStudy}</div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group float-label-control">
                        <input id="emailId" type="email" className="form-control" placeholder="Email id (something@example.com)"
                               onChange={this.handleInputChange} value={this.state.emailId}/>
                        <div className="errorMsg">{this.state.errors.emailId}</div>
                    </div>
                    <div className="form-group float-label-control">
                        <input id="phoneNumber" type="tel" className="form-control"
                               placeholder="Phone Number (9876543210)"
                               pattern="[0-9]{10}" maxLength="10" onChange={this.handleInputChange}
                               value={this.state.phoneNumber}/>
                        <div className="errorMsg">{this.state.errors.phoneNumber}</div>
                    </div>
                    <div className="form-group">
                        <div className="inputGroupContainer">
                            <div className="form-group">
                                <label htmlFor="howDoYouKnowAboutUs">How do you know about us ?</label>
                                <select className="form-control" id="howDoYouKnowAboutUs"
                                        onChange={this.handleInputChange}
                                        value={this.state.howDoYouKnowAboutUs}>
                                    <option value="Select">Select</option>
                                    <option value="Social Media">Social Media</option>
                                    <option value="Friends/Family">Friends/Family</option>
                                    <option value="Faculty/College">Faculty/College</option>
                                    <option value="WhatsApp/SMS">WhatsApp/SMS</option>
                                    <option value="Others">Others</option>
                                </select>
                                <div className="errorMsg">{this.state.errors.howDoYouKnowAboutUs}</div>
                            </div>
                        </div>
                    </div>
                    {price ?
                        <div>
                            <h5>Payment Process:</h5>
                            <p><strong>Step1:</strong> Scan the below QR Code and make payment
                                of <strong>{price}</strong></p>
                            <table>
                                <tr>
                                    <td><img src={upiQRCode} alt={"sugyantechnologies@upi"}/></td>
                                    <td><p>You can also pay using GooglePay/PhonePe/Any UPI App to
                                        VPA: <strong>sugyantechnologies@upi</strong></p></td>
                                </tr>
                            </table>
                            <p><strong>Step2:</strong> Share the transaction screenshot to our WhatsApp number: <strong>+91
                                99595 01857</strong></p>
                            <p>or email the screenshot to <a
                                href="mailto:team@engineeringguru.in">team@engineeringguru.in</a></p>
                        </div>
                        : <div/>
                    }
                </div>
                <div className="container d-flex justify-content-center">
                    <button type="button" className="btn btn-success" onClick={this.saveDetails}>Save & Register</button>
                </div>
                <br />
                <div className="container d-flex justify-content-center">
                    {
                        this.state.formIsValid ?
                            <div className="successMsg">{this.state.successMsg}</div>
                            :
                            <div className="errorMsg">{this.state.errorMsg}</div>
                    }
                </div>
            </div>
        );
    }
}

RegisterForCourse.propTypes = {};

export default RegisterForCourse;
